/** Germination review: the Review link off the germination verification grid. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { z } from "zod";
import { GerminationReviewPage } from "@/features/quality/components/germination/germination-review-page";

export const Route = createFileRoute("/_app/quality/germination/$sampleId")({
  params: {
    parse: ({ sampleId }) => {
      if (!/^\d+$/.test(sampleId)) throw notFound();
      return { sampleId };
    },
    stringify: (p) => p,
  },
  validateSearch: z.object({
    round: z.coerce.number().int().positive().optional(),
  }),
  // The Lab Manager reads it too, and sets the tray up from it; only qc.verify verifies.
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (!can("qc.verify") && !can("qc.germination_setup"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { sampleId } = Route.useParams();
  const { round } = Route.useSearch();
  return <GerminationReviewPage id={Number(sampleId)} round={round} />;
}
